$ = require 'jquery'

module.exports = 
  (->
    $(document).ready ->
      $(".nav-link, .nav-link-logo").click (event) ->
        event.preventDefault()
        $anchor = $(this)
        navHeight = $("nav.nav").outerHeight()
        portfolioContentTop = $("section.portfolio-content").position().top
        usableTop = 0
        $("html, body").stop().animate
          scrollTop: $($anchor.attr("href")).offset().top - navHeight
        , 800
        return

      return

    return
  )()